module.exports = __webpack_public_path__ + "img/video-thumb-1.93e738d1.jpg";